import { ButtonsGroup } from 'components/shared/ButtonsGroup/ButtonsGroup';
import type { UnderlyingCodeType } from 'models/underlying/base';
import { FC, ReactNode, useCallback } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

import { FlexRowGroup } from './RowGroup';
import { SectionTitle, TabForm } from './TabForm';

interface UnderlyingTabProps {
  children?: ReactNode;
  onClose: () => void;
  underlyingCodeType: string;
  onUnderlyingCodeTypeChanged: (value: UnderlyingCodeType) => void;
}

const availableUnderlyingCodeTypes = ['Bloomberg', 'Reuters'];

export const UnderlyingTabForm: FC<UnderlyingTabProps> = ({
  onClose,
  underlyingCodeType,
  onUnderlyingCodeTypeChanged,
  children,
}) => {
  const onSpecificUnderlyingCodeTypeChanged = useCallback(
    (value: string) => {
      logAnalytics.trackEvent('User preferences', 'Set underlying code type', value);
      return onUnderlyingCodeTypeChanged(value as UnderlyingCodeType);
    },
    [onUnderlyingCodeTypeChanged],
  );

  return (
    <TabForm labelKey="userPreferencesForm.underlyings.label" onClose={onClose}>
      <SectionTitle labelKey="userPreferencesForm.defaultValues.label" />
      <FlexRowGroup labelKey="userPreferencesForm.underlyingCodeTypes.label" isFirst>
        <ButtonsGroup
          className="w-100"
          items={availableUnderlyingCodeTypes}
          selectedItems={underlyingCodeType}
          onSelect={items => onSpecificUnderlyingCodeTypeChanged(items[0])}
          isRadio
          translationPrefix="form.UnderlyingCodeType"
        />
      </FlexRowGroup>
      {children}
    </TabForm>
  );
};

UnderlyingTabForm.displayName = 'UnderlyingTabForm';
